import {
    Divider,
    Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    
  } from "@chakra-ui/react";
  import React, {  useState, useMemo } from "react";

  import Form from "react-bootstrap/Form";
  import Col from "react-bootstrap/Col";
  import Row from "react-bootstrap/Row";
  import moment from "moment";
  import { poNumberFormate } from "jsFunctions/helperFunctions";
  import { InputGroup, Tab, Tabs } from "react-bootstrap";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import GstInfo from "./components/gstInfo";
import PaymentInfo from "./components/paymentInfo";
import InvoiceInfo from "./components/invoicceInfo";
import RefundInfo from "./components/refundInfo";
import { calculateTotalCredit } from "jsFunctions/helperFunctions";
import { sumOfPaymentRecordAmount } from "utiils/halper";
  
  const DataRow = ({ label, value,type }) => {
    return (
      <>
        <Form.Label>{label}</Form.Label>
      {type === 'Amount' 
      ?
      <InputGroup>
        <InputGroup.Text style={{height:'2rem', border:0, background:'lightGray'}}><span className="rupee-symbol">₹</span> </InputGroup.Text>
        <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? formatAmountIndianRupees(value) : " "}
        disabled
      />
      </InputGroup>
      :
      <Form.Control
        type="text"
        value={value !== "undefined" && value !== "" ? value : " "}
        disabled
      />
      }
      </>
    );
  };
  
  const ExpenseInfoModel = ({ openInfoModal, closeInfoModal, selectedItem, role, expenseType }) => {
  
    const [activeTab, setActiveTab] = useState("information");
    const [historyTab, setHistoryTab] = useState("requested");  

    const getPoMonth = useMemo(() => {
      if (selectedItem.oM) {
        const date = moment(selectedItem.oM);
        const month = date.format("MMM");
        const year = date.format("YYYY");
        return `${year}-${month}`;
      }
      return "";
    }, [selectedItem.oM]);
  
    const remainingAmount = useMemo(() => {
      const list = selectedItem?.pyInfo?.list || [];
      const crList = selectedItem?.crApl?.list || [];
      const sumOfCredit = calculateTotalCredit(crList)
      const total = sumOfPaymentRecordAmount(list)
      
      const totalPayAmount = parseFloat(selectedItem?.pyInfo?.tlAmt || 0) - parseFloat(selectedItem?.tdsApl?.tlAmt || 0) - parseFloat(sumOfCredit) - parseFloat(total);
      
  
      return totalPayAmount;
    }, [selectedItem]);
  

    const merchantName = useMemo(() => {
      const vId = selectedItem?.mrId || selectedItem?.resId
      if (vId) {
          return vId.name || "";
      }
  }, [selectedItem]);
  
    return (
      <div>
        <Modal
          isOpen={openInfoModal}
          onClose={closeInfoModal}
          size="xl"
          className="modal-main"
        >
          <ModalOverlay />
          <ModalContent 
           top="0" // Position it at the top
           margin="0 auto" // Center it horizontally
           bottom="0"
           className="info-model"
          >
            <div className="fixed-header">
              <ModalHeader className="expense-modal-header mt-0">
                <span>{expenseType} Expense</span>
              </ModalHeader>
              <ModalCloseButton />
            </div>
            <ModalBody>
              <Form className="addForm">
                <Tabs
                  id="justify-tab-example1"
                  activeKey={activeTab}
                  onSelect={(k) => setActiveTab(k)}
                  className=""
                  justify
                >
                  <Tab
                    eventKey="information"
                    title="Information"
                    className="main-tab-item"
                  >
                    <div className="card">
                      <h5 className="heading-h5"> Purchase Order Details</h5>
  
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Order Number"
                            value={poNumberFormate(selectedItem.poNo)}
                          />
                        </Col>
                        <Col>
                          <DataRow label="Order Month" value={getPoMonth} />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Order Date"
                            value={
                              selectedItem.oDt
                                ? moment(selectedItem.oDt).format(
                                    "DD-MMM-yyyy"
                                  )
                                : ""
                            }
                          />
                        </Col>
                        <Col></Col>
                      </Row>
  
                      <Divider
                        className="info-divider"
                        orientation="horizontal"
                        m={3}
                      />
                      <h5 className="heading-h5">Expense</h5>
  
                      <Row className="info-row">
                       
                        <Col>
                          <DataRow
                            label="Major Type"
                            value={selectedItem?.mjId?.val}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Minor Type"
                            value={selectedItem.mnId?.val}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                      
                        <Col>
                          <DataRow
                            label="Minor Sub Category"
                            value={selectedItem.msId?.val}
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Client Name"
                            value={selectedItem?.clId?.clName}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        
                      
                        <Col>
                          <DataRow
                            label="Project Name"
                            value={selectedItem?.prId?.prj}
                          />
                        </Col>
                        <Col>
                        
                            <DataRow
                            label="Merchant Name"
                            value={merchantName}
                          />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <Form.Label>Remarks</Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            disabled
                            value={selectedItem?.rmks}
                          />
                        </Col>
                      </Row>
                    
                      <Row className="info-row">
                      
  
                        <Col className="check-cross-mark">
                          <Form.Label>
                            <span
                              className={
                                selectedItem.exp.sts
                                  ? "checkmark"
                                  : "crossmark"
                              }
                            ></span>{" "}
                            Is it Freight Expense?
                          </Form.Label>
                        </Col>
                        <Col></Col>
                      </Row>
  
                      {selectedItem.exp.sts && (
                        <Row className="info-row mb-3">
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                label="Delivery Partner"
                                value={selectedItem.exp?.adId?.val}
                              />
                            </Flex>
                          </Col>
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                label="Tracking Number"
                                value={selectedItem.exp.trkNo}
                              />
                            </Flex>
                          </Col>
                        </Row>
                      )}
                     
                      <Divider
                      className="info-divider"
                      orientation="horizontal"
                    />
                    <h5 className="heading-h5">TDS Applicable</h5>
                    <Row className="info-row">
                      <Col className="check-cross-mark mt-0">
                        <Form.Label>
                          <span
                            className={
                              selectedItem?.tdsApl?.sts
                                ? "checkmark"
                                : "crossmark"
                            }
                          ></span>{" "}
                          Is TDS applicable?
                        </Form.Label>
                      </Col>
                    </Row>

                    {selectedItem?.tdsApl?.sts && (
                      <>
                        <Row className="info-row">
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                label="Total Amount "
                                value={selectedItem?.tdsApl?.bsAmt}
                                type="Amount"
                              />
                            </Flex>
                          </Col>
                          <Col>
                          <Flex direction="column">
                              <DataRow
                                label="TDS PO   "
                                value={
                                  selectedItem?.tdsApl?.tdsPo
                                    .sts
                                    ? poNumberFormate(
                                        selectedItem?.tdsApl?.tdsPo?.poNo
                                      )
                                    : ""
                                }
                              />
                            </Flex>
                          </Col>
                        </Row>
                        <Row className="info-row">
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                type="Amount"
                                label="TDS Amount  "
                                value={selectedItem?.tdsApl?.tlAmt}
                              />
                            </Flex>
                          </Col>
                          <Col>
                            
                          </Col>
                        </Row>
                      </>
                    )}

                      <Divider
                        className="info-divider"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Reimbursement Information</h5>
                     
                      <Row className="info-row">
                        <Col className="check-cross-mark mt-0">
                          <Form.Label>
                            <span
                              className={
                                selectedItem.rmbInfo
                                .isRmb?.sts
                                  ? "checkmark"
                                  : "crossmark"
                              }
                            ></span>{" "}
                            Is it Reimbursed?
                          </Form.Label>
                        </Col>
                      </Row>
  
                      {selectedItem.rmbInfo.isRmb?.sts && (
                        <>
                         <Row className="info-row mb-3">
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                label="Invoice Number "
                                value={selectedItem.rmbInfo?.inNo}
                              />
                            </Flex>
                          </Col>
                          <Col>
                            <Flex direction="column">
                              <DataRow
                                label="Invoice Date"
                                value={
                                  selectedItem.rmbInfo?.inDt
                                    ? moment(selectedItem.rmbInfo?.inDt).format(
                                        "DD-MMM-yyyy"
                                      )
                                    : ""
                                }
                              />
                            </Flex>
                          </Col>
                        </Row>
                          <Row className="info-row">
                            <Col>
                              <Flex direction="column">
                                <DataRow
                                  label="Payment Date"
                                  value={
                                    selectedItem.rmbInfo
                                .isRmb?.pmtDt
                                      ? moment(selectedItem.rmbInfo
                                        .isRmb?.pmtDt).format(
                                          "DD-MMM-yyyy"
                                        )
                                      : ""
                                  }
                                />
                              </Flex>
                            </Col>
                            <Col></Col>
                           
                          </Row>
                          <Row className="info-row">
                          <Col>
                              <Flex direction="column">
                                <DataRow
                                  label="Currency "
                                  value={selectedItem.rmbInfo
                                    .isRmb?.crId?.val}
                                />
                              </Flex>
                            </Col>
                            <Col>
                              <Flex direction="column">
                                <DataRow
                                  type='Amount'
                                  label="Amount  "
                                  value={selectedItem.rmbInfo
                                    .isRmb?.amt}
                                />
                              </Flex>
                            </Col>
                          </Row>
                          <Row className="info-row">
                           
                            <Col>
                              <Flex direction="column">
                                <DataRow
                                  label="Coversion Rate  "
                                  value={selectedItem.rmbInfo
                                    .isRmb?.cnvRt}
                                />
                              </Flex>
                            </Col>
                            <Col>
                              <Flex direction="column">
                                <DataRow
                                  type='Amount'

                                  label="Amount in INR "
                                  value={selectedItem.rmbInfo
                                    .isRmb?.inr}
                                />
                              </Flex>
                            </Col>
                           
                           
                          </Row>
                        </>
                      )}
                     
                   
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Payment Information</h5>
                      <PaymentInfo selectedItem = {selectedItem} remainingAmount={remainingAmount} expenseType="custom"/>

                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Refund Amount Information</h5>
                      <RefundInfo selectedItem = {selectedItem}/>
  
                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Invoice</h5>
                      <InvoiceInfo selectedItem={selectedItem} />
                      
                      <Divider
                      className="info-divider mt-3"
                      orientation="horizontal"
                    />
                   <h5 className="heading-h5">GST Applicable</h5>
                   <GstInfo selectedItem={selectedItem} />
                    </div>
                  </Tab>
                  {role === "Manager" || role === "Admin" ? (
                    <Tab eventKey="history" title="History">
                      <Form className="addForm addform2">
                        <Tabs
                          id="justify-tab-example3"
                          activeKey={historyTab}
                          onSelect={(k) => setHistoryTab(k)}
                          transition={true}
                          className="mt-0"
                        >
                          <Tab
                            eventKey="requested"
                            className="inner-tab"
                            title="Requested"
                          >
                            <div className="inner-card">
                              <h5 className="heading-h5">Requested Amount Details</h5>
                              <Row className="info-row">
                                <Col className="check-cross-mark mt-2">
                                  <Form.Label>
                                    <span
                                      className={
                                        selectedItem.pyInfo.sts !== 0
                                          ? "checkmark"
                                          : "crossmark"
                                      }
                                    ></span>{" "}
                                    Is requested amount send for approval?
                                  </Form.Label>
                                  <br />
                                </Col>
                              </Row>
                              <Row className="info-row">
                                <Col>
                                  <DataRow
                                    label="Requested At"
                                    value={
                                      selectedItem.pyInfo?.rqAt
                                        ? moment(
                                            selectedItem.pyInfo?.rqAt
                                          ).format("DD-MMM-yyyy hh:mm A")
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col>
                                  <DataRow
                                    label="Requested By"
                                    value={selectedItem.pyInfo?.rqBy?.name}
                                  />
                                </Col>
                              </Row>
  
                              <Divider
                                className="info-divider mt-3"
                                orientation="horizontal"
                              />
                              <h5 className="heading-h5">Last Updated Details</h5>
  
                              <Row className="info-row mb-3">
                                <Col>
                                  <DataRow
                                    label="Last Updated At"
                                    value={
                                      selectedItem.upAt
                                        ? moment(
                                            selectedItem.upAt
                                          ).format("DD-MMM-yyyy hh:mm A")
                                        : ""
                                    }
                                  />
                                </Col>
                                <Col>
                                  <DataRow
                                    label="Last Updated By"
                                    value={selectedItem.upBy?.name}
                                  />
                                </Col>
                              </Row>
                            </div>
                          </Tab>
  
                          {selectedItem.pyInfo?.sts !== 2
                      ?
                      <Tab eventKey="approved" title="Approved">
                      <div className="inner-card">
                        <h5 className="heading-h5">Requested Amount Details</h5>
                        <Row className="info-row">
                          <Col className="check-cross-mark mt-2">
                            <Form.Label>
                              <span
                                className={
                                    selectedItem.pyInfo?.sts === 1
                                    ? "checkmark"
                                    : "crossmark"
                                }
                              ></span>{" "}
                              Is requested amount is approved ?
                            </Form.Label>
                            <br />
                          </Col>
                        </Row>
                        <Row className="info-row">
                          <Col>
                            <DataRow
                              label="Approved At"
                              value={
                                selectedItem.pyInfo?.acnAt
                                  ? moment(
                                      selectedItem.pyInfo?.acnAt
                                    ).format("DD-MMM-yyyy hh:mm A")
                                  : ""
                              }
                            />
                          </Col>
                          <Col>
                            <DataRow
                              label="Approved By"
                              value={selectedItem.pyInfo?.acnBy?.name}
                            />
                          </Col>
                        </Row>

                        <Divider
                          className="info-divider mt-3"
                          orientation="horizontal"
                        />
                        <h5 className="heading-h5">Last Updated Details</h5>

                        <Row className="info-row mb-3">
                          <Col>
                            <DataRow
                              label="Last Updated At"
                              value={
                                selectedItem.upAt
                                  ? moment(
                                      selectedItem.upAt
                                    ).format("DD-MMM-yyyy hh:mm A")
                                  : ""
                              }
                            />
                          </Col>
                          <Col>
                            <DataRow
                              label="Last Updated By"
                              value={selectedItem.upBy?.name}
                            />
                          </Col>
                        </Row>
                      </div>
                    </Tab>
                    :
                    <Tab eventKey="approved" title="Rejected">
                    <div className="inner-card">
                      <h5 className="heading-h5">Requested Amount Details</h5>
                      <Row className="info-row">
                        <Col className="check-cross-mark mt-2">
                          <Form.Label>
                            <span
                              className={
                                selectedItem.pyInfo?.sts !== 2
                                  ? "checkmark"
                                  : "crossmark"
                              }
                            ></span>{" "}
                            Is requested amount is rejected ?
                          </Form.Label>
                          <br />
                        </Col>
                      </Row>
                      <Row className="info-row">
                        <Col>
                          <DataRow
                            label="Rejected At"
                            value={
                              selectedItem.pyInfo?.acAt
                                ? moment(
                                    selectedItem.pyInfo?.acAt
                                  ).format("DD-MMM-yyyy hh:mm A")
                                : ""
                            }
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Rejected By"
                            value={selectedItem.pyInfo?.acnBy?.name}
                          />
                        </Col>
                      </Row>

                      <Divider
                        className="info-divider mt-3"
                        orientation="horizontal"
                      />
                      <h5 className="heading-h5">Last Updated Details</h5>

                      <Row className="info-row mb-3">
                        <Col>
                          <DataRow
                            label="Last Updated At"
                            value={
                              selectedItem.upAt
                                ? moment(
                                    selectedItem.upAt
                                  ).format("DD-MMM-yyyy hh:mm A")
                                : ""
                            }
                          />
                        </Col>
                        <Col>
                          <DataRow
                            label="Last Updated By"
                            value={selectedItem.upBy?.name}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Tab>
                      }
                        </Tabs>
                      </Form>
                    </Tab>
                  ) : (
                    <Tab eventKey="" title="" disabled></Tab>
                  )}
                </Tabs>
              </Form>
            </ModalBody>
          </ModalContent>
        </Modal>
      </div>
    );
  };
  
  export default ExpenseInfoModel;
  